export const EventStatus = {
    "REQUESTED": 0,
    "IN_REVIEW": 1,
    "CONFIRMED": 2,
    "ONGOING": 3,
    "COMPLETED": 4,
    "CANCELLED": 5,
    "PREORDER": 6,
    "PRE_ORDER_FULFILLMENT": 7
  }